exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-bg-color[data-v-5b0e2b88]{background-color:#f5f4e8\n}\n.btn-download-app[data-v-5b0e2b88]{max-width:140px;max-height:45px\n}", ""]);

// exports
